require('./verticalStepper.styles.css');
const template = require('./verticalStepper.template');
type VerticalStepperScope = ng.IScope & { vm: VerticalStepperController };
type VerticalStepScope = ng.IScope & { vm: VerticalStepController };


export class VerticalStepperController implements ng.IController{
	public static $inject = [
	];

    public activeStep:number = 0;
    public updateActiveStep:Function;
    public step:number = 0;
    public stepsCompleted:Function;
    public currentStepValid:Function;

	constructor(){

    }

    public next(){
        this.activeStep++;
        this.step = this.activeStep;
        this.updateActiveStep();
    }
    
    public back(){
        this.activeStep--;
        this.step = this.activeStep;
        this.updateActiveStep();
    }

    public jump(step:number) {
        if (!this.isValidJump(step)) {
            return;
        }
        this.activeStep = this.step = step;
        this.updateActiveStep();
    }

    private isValidJump(step:number) {
        // allow jumping to any previous step or immediate next step after current step is complete.
        return step - this.activeStep < 0 || step - this.activeStep === 1 && this.currentStepValid()
    }
}

export let VerticalStepperDirective = function($timeout:ng.ITimeoutService): ng.IDirective {
    return {
        restrict: 'E',  
        controller: VerticalStepperController,
        controllerAs: 'vm',
        bindToController: true,
        scope:{
            step:'=',
            stepsCompleted:'&'
        },
        link: (scope:VerticalStepperScope, element, attrs) => {  
            scope.vm.updateActiveStep = function(){
                element.attr('active-step', scope.vm.activeStep.toString());
            };

        }
    };
}
VerticalStepperDirective.$inject = [
    '$timeout'
];

export class VerticalStepController implements ng.IController {
    public static readonly $inject = [
    ];

    private header:string;
    private description:string;
    public stepIndex:number;
    public isFirstStep:boolean;
    public isLastStep:boolean;
    public currentStepIndex:number;
    public stepNumber:string;
    public next:Function;
    public back:Function;
    public jump:Function;
    public done:Function;
    public active:boolean = false;
    public stepForm:ng.IFormController;

    constructor(

    ) {        
    }

    private get stepIsComplete(){ return this.stepIndex < this.currentStepIndex;}
}

export let VerticalStepDirective = function($timeout:ng.ITimeoutService): ng.IDirective {
    return {
        require:'^^sbVerticalStepper',
        template,
        controller: VerticalStepController,
        controllerAs:'vm',
        transclude:true,
        bindToController:true,
        scope: {
            header: '@',
            description: '@'
        },
        link: (scope:VerticalStepScope, element, attrs, controller:VerticalStepperController) => {  
            if(!angular.isDefined(VerticalStepperController)){
                throw new Error('Vertical step directive requires vertical stepper directive.');
            }

            let vm = scope.vm;

            vm.next = ()=>{controller.next()};
            vm.back = ()=>{controller.back()};
            vm.jump = (stepIndex:number) => controller.jump(stepIndex - 1);
            vm.done = controller.stepsCompleted;

            scope.$watch(() => element.parent().attr('active-step'), newVal => {
                if(!newVal){ return; }
                
                vm.active = newVal.toString()===vm.stepIndex.toString() ? true : false;
                if (vm.active) {
                    controller.currentStepValid = () => vm.stepForm.$valid;
                }
                vm.currentStepIndex = parseInt(newVal);
            });
            

            let steps = element.parent().find('sb-vertical-step');
            angular.forEach(steps,(step, i) => {
                let elm = angular.element(step);
                if(element[0] == elm[0]){
                    vm.active = vm.isFirstStep = i === 0;
                    if (vm.active) {
                        controller.currentStepValid = () => vm.stepForm.$valid;
                    }
                    vm.isLastStep = i === steps.length - 1;
                    vm.stepIndex = i;
                    vm.stepNumber = i+1;
                }
            });
    
           
        }
    };
}
VerticalStepDirective.$inject = [
    '$timeout'
];



// WEBPACK FOOTER //
// ./src/sharebase/components/verticalStepper/verticalStepper.ts